var map = {
	"./account-statement-small.svg": "8ace",
	"./arrow-right.svg": "cd8c",
	"./arrow.svg": "21e2",
	"./change-info-small.svg": "9411",
	"./check-white.svg": "5131",
	"./coins-exchange.svg": "f4d2",
	"./copy.svg": "8aac",
	"./default-avatar.svg": "af68",
	"./dropdown.svg": "6d05",
	"./error.png": "c7fe",
	"./graph.svg": "07ee",
	"./hidden-icon.svg": "4bf0",
	"./loader.svg": "04ff",
	"./pending-2.svg": "6b1e",
	"./pending-withdrawal.svg": "c190",
	"./pending.svg": "e25a",
	"./quote-icon.svg": "9e47",
	"./referral-link-small.svg": "f91f",
	"./referral-link-svg.svg": "7450",
	"./success.png": "f0a6",
	"./visible-icon.svg": "ab89",
	"./wallet.svg": "4f4a",
	"./warning-icon.svg": "209f",
	"./warning.svg": "daa9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";